// extracted by mini-css-extract-plugin
module.exports = {"location":"Location_pc_location__z8mGG","address":"Location_pc_address__yzjsc","distance":"Location_pc_distance__rKxLN","viewMap":"Location_pc_viewMap__JUcrY"};